import branch from '@/api/corporate/branch'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  provinces: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_PROVINCES(state, value) {
    state.provinces = value
  },
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search
        }
      },
      attrubutes
    )
    return branch.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return branch.store(data)
  },
  update(context, { id, data }) {
    return branch.update(id, data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await branch.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  destroy(context, id){
    return branch.destroy(id)
  },
  upload(context, data) {
    return branch.upload(data.get('id'), data)
  },
  company(context) {
    return branch.company()
  },
  async fetchResources(context) {
    if (!context.state.provinces.length > 0) {
      let province_response = await branch.province()
      context.commit('SET_PROVINCES', province_response.data)
    }
  },
  getDistrict(context, province_code) {
    if (!province_code) return
    return branch.district(province_code)
  },
  getCommune(context, district_code) {
    if (!district_code) return
    return branch.commune(district_code)
  },
  getVillage(context, commune_code) {
    if (!commune_code) return
    return branch.village(commune_code)
  }
}
